var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.452 38.7017C173.143 35.2762 170 33 166.364 33C122.133 33 77.9122 33 33.6807 33C28.8817 33 25.0224 36.8606 25 41.6474C25 70.7585 25 99.8807 25 128.992C25 133.756 28.8929 137.595 33.6919 137.606C47.4625 137.617 61.2331 137.606 74.9925 137.606H165.178C170.391 137.606 173.065 135.72 174.799 130.811C174.821 130.732 174.922 130.666 174.989 130.599V40.0183C174.799 39.572 174.608 39.148 174.441 38.7017H174.452ZM166.096 128.746H33.8485V41.8371H166.096V128.746Z",
    fill: "#F4BF35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.497 159.241H123.251V137.606H76.7935V159.241H53.5815C50.6954 159.241 48.7601 160.982 48.7377 163.559C48.7154 166.226 50.6506 168 53.6039 168H146.452C149.327 168 151.251 166.237 151.262 163.637C151.273 161.038 149.349 159.252 146.497 159.241ZM114.28 159.13H85.7427V137.673H114.28V159.13Z",
    fill: "#EA8632"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 135,
    fill: "white",
    transform: "translate(25 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/PC.742648beb633896a3662196801a18c75.svg";
export { ForwardRef as ReactComponent };